import { ObjectFieldTemplateProps } from "@rjsf/utils";
import useUpdateSectionAction from "../../actions/updateSection/useUpdateSectionAction";
import { Col, Row } from "react-bootstrap";

function DisclaimersTemplate(props: ObjectFieldTemplateProps, func: any) {
  const { actionTemplate } = useUpdateSectionAction();
  return (
    <section className="cms-section">
      <h2 className="cms-section-title">
        {props.title} {actionTemplate}{" "}
      </h2>
      <div className="cms-section-content">
        <Row>
          <Col sm={6}>
            <div className="property-wrapper">{func("highlights", props)?.content}</div>
          </Col>
          <Col sm={6}>
            <div className="property-wrapper">{func("lowlights", props)?.content}</div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default DisclaimersTemplate;
